<template>
  <div>
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      :variant="variant"
      @dismissed="closeToast"
      @dismiss-count-down="countDownChanged"
    >
        <div class="toast-title">{{title}}</div>
        <div class="toast-message">{{message}}</div>
    </b-alert>
  </div>
</template>

<script>
export default {
  props: {
    timer: {
      type: Number,
    },
    variant: {
      type: String,
      default: "danger"
    },
    title: String,
    message: String,
    index:Number
  },
  data() {
    return {
      dismissCountDown: 0,
      newTimer:this.timer
    };
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    closeToast(){
        this.dismissCountDown=0
        this.$store.dispatch("Menu/removeToast",this.index)
    }
  },
  mounted(){
      this.dismissCountDown=this.timer
  }
};
</script>
<style scoped>
 .toast-title{
     font-size: 24px;
     font-weight: 600;
 }
 .toast-message{
     font-weight: 600;
 }
</style>